/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FilterBuilderColumnDto } from './FilterBuilderColumnDto';
import {
    FilterBuilderColumnDtoFromJSON,
    FilterBuilderColumnDtoFromJSONTyped,
    FilterBuilderColumnDtoToJSON,
} from './FilterBuilderColumnDto';

/**
 * 
 * @export
 * @interface FilterBuilderDto
 */
export interface FilterBuilderDto {
    /**
     * 
     * @type {Array<FilterBuilderColumnDto>}
     * @memberof FilterBuilderDto
     */
    columns?: Array<FilterBuilderColumnDto>;
}

/**
 * Check if a given object implements the FilterBuilderDto interface.
 */
export function instanceOfFilterBuilderDto(value: object): value is FilterBuilderDto {
    return true;
}

export function FilterBuilderDtoFromJSON(json: any): FilterBuilderDto {
    return FilterBuilderDtoFromJSONTyped(json, false);
}

export function FilterBuilderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterBuilderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'columns': json['columns'] == null ? undefined : ((json['columns'] as Array<any>).map(FilterBuilderColumnDtoFromJSON)),
    };
}

export function FilterBuilderDtoToJSON(value?: FilterBuilderDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'columns': value['columns'] == null ? undefined : ((value['columns'] as Array<any>).map(FilterBuilderColumnDtoToJSON)),
    };
}

